import React from 'react';

const About = () => {
  return (
    <section id="about" className="container mb-5 about-page">
        
        <h2 className="heading">About Us</h2>
        {/* <h5>Thematic work area - Education  </h5> */}
        <div>
            <p>
                 Janpravaha Social Foundation as the name suggests, it makes an effort to understand the
                needs of the different segments of society & work as facilitator for mainstreaming the
                unacknowledged sector of society.
            </p>
            <p>
                It’s a non-profit organization in Maharashtra working in
                the field of education, development initiatives, infrastructure equipping, health care
                management, skill development & enhancement activities, environment sustenance activities,
                rural development, rehabilitation etc. towards the betterment of individuals.
            </p>
            <p>
               Since the
                organization being novice, we are working at different levels and are keen on opening new
                opportunities. This will definitely help us to plant and strengthen our roots in social welfare
                activities.
            </p>
            <p>
               We do feel that individuals have their own competencies, it is more of giving
                exposure and thus our team works with the approach of enrichment. Thus, the ideology of our
                organization works for individuals to be more self-reliant.
            </p>
        </div>  
    </section>
  );
};

export default About;
